<mmx-history-dialog
  [title]="'Insurance History'"
  [history$]="history$"
  [loading$]="patientDataService.insuranceHistoryLoading$"
  [emptyText]="'No insurance history available.'"
  [tz]="tz"
  [logRowClass]="'mb-2'"
>
  <ng-template let-log>
    <strong>{{ getHistoryTypeName(log.type) }}</strong> by {{ getActorName(log) }}.
    <br />
    <em>{{ log.message }}</em>
    <ul *ngIf="log.messageData?.updatedValues as updatedValues" class="pl-4">
      <li *ngFor="let entry of updatedValues | keyvalue">
        <strong>{{ 'dialog.patient-insurance-history.updates.' + entry.key | translate }}:</strong>
        <ng-container [ngSwitch]="entry.key">
          <ng-container *ngSwitchCase="'eligibilityStatus'">
            <span class="strikethrough color red">
              @if (entry.value.oldValue) {
                {{ getEligibilityStatusText(entry.value.oldValue) | translate }}
              } @else {
                {{ 'common.none' | translate }}
              }
            </span>
             ->
            <b class="color green">
              {{ getEligibilityStatusText(entry.value.newValue) | translate }}
            </b>
          </ng-container>
          <ng-container *ngSwitchCase="'status'">
            <span class="strikethrough color red">
              @if (entry.value.oldValue) {
                {{ getPatientInsuranceStatusText(entry.value.oldValue) | translate }}
              } @else {
                {{ 'common.none' | translate }}
              }
            </span>
            ->
            <b class="color green">
              {{ getPatientInsuranceStatusText(entry.value.newValue) | translate }}
            </b>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <span class="strikethrough color red">
              {{ entry.value.oldValue ?? ('common.none' | translate) }}
            </span>
             ->
            <b class="color green">
              @if (!entry.value.newValue) {
                 {{ 'common.none' | translate }}
              } @else if (isDate(entry.value.newValue)) {
                 {{ entry.value.newValue | date: 'shortDate' }}
              } @else {
                 {{ entry.value.newValue }}
              }
            </b>
          </ng-container>
        </ng-container>
      </li>
    </ul>
  </ng-template>
</mmx-history-dialog>
